import "../../global.css";
import "./store.css";
import CustomGrid from "../../components/grid/CustomGrid";
import { useEffect } from "react";
import { useState } from "react";
import { userRequest } from "../../requestMethods";
import IconButton from "@mui/material/IconButton";
import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import { useCompany } from "../../components/context/CompanyContext";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import { titleSetRef } from "../../redux/titleRedux";
export default function StoreList() {
  const [stores, setStores] = useState([{}]);
  const { companyId } = useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(titleSetRef({ title: "Loja" }));
    if (companyId > 0) {
      getStores();
    }
  }, [companyId]);

  const getStores = async () => {
    try {
      const res = await userRequest.get(`${companyId}/store`);
      setStores(res.data);
    } catch {
      console.log();
    }
  };
  const addStore = async () => {
    let valida = false;
    if (inputs && inputs.store !== "") {
      valida = true;
    } else {
      Swal.fire("Atenção!", "O campo Loja deve ser preenchido.", "warning");
      valida = false;
      return;
    }

    if (valida) {
      const res = await userRequest.post(`${companyId}/store`, {
        store: inputs.store.toUpperCase(),
        // CNPJ da conta do ERP desta loja (opcional). É o que permite a uma
        // company ter uma conta por loja — ex.: 2 tokens Bling, um por CNPJ.
        integrationId: inputs.integrationId || null,
      });
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Loja criada com sucesso!", "success");
        getStores();
      }
    }
  };
  const deleteStore = async (cp) => {
    const res = await userRequest.put(`${companyId}/store/${cp}`, {
      deleted: new Date(),
      lastUserUpdate: currentUser.userId,
    });

    if (res.data > 0) {
      getStores();
    } else {
      Swal.fire("Atenção!", "Erro ao excluir loka!", "error");
    }
  };
  const onButtonDeleteClick = async (e, row) => {
    if (currentUser.isAdmin) {
      Swal.fire({
        title: "Tem certeza que deseja excluir?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, excluir!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          deleteStore(row);
        }
      });
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para excluir loja!",
        "warning",
      );
    }
  };
  // Vincula (ou troca) a conta do ERP da loja pelo CNPJ. O backend normaliza
  // para só dígitos, que é como o callback do OAuth procura a loja.
  const editIntegrationId = async (row) => {
    const { value, isConfirmed } = await Swal.fire({
      title: `CNPJ da integração — ${row.store}`,
      input: "text",
      inputValue: row.integrationId || "",
      inputLabel: "CNPJ da conta do ERP desta loja (vazio remove o vínculo)",
      showCancelButton: true,
      confirmButtonText: "Salvar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#EE8253",
    });

    if (!isConfirmed) return;

    const res = await userRequest.put(`${companyId}/store/${row.storeId}`, {
      integrationId: value ? value : null,
      lastUserUpdate: currentUser.userId,
    });

    if (res.data > 0) {
      getStores();
    } else {
      Swal.fire("Atenção!", "Erro ao salvar o CNPJ da integração!", "error");
    }
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const columns = [
    {
      field: "storeId",
      type: "number",
      align: "left",
      headerName: "Id",
      width: 100,
    },
    {
      field: "store",
      type: "text",
      align: "left",
      headerName: "Store",
      width: 100,
      clickable: true,
    },
    {
      field: "integrationId",
      type: "text",
      align: "left",
      headerName: "CNPJ Integração",
      width: 180,
      renderCell: (params) => (
        <span>
          {params.row.integrationId || "—"}
          <IconButton
            size="small"
            title="Vincular conta do ERP a esta loja"
            onClick={() => editIntegrationId(params.row)}
          >
            <EditOutlined fontSize="small" />
          </IconButton>
        </span>
      ),
    },
    {
      field: "createdAt",
      type: "date",
      headerName: "Criada em",
      width: 100,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
    },
    {
      field: "deleted",
      type: "date",
      headerName: "Inativado",
      width: 100,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
    },
    {
      field: "deletar",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      display: "flex",
      renderCell: (params) => {
        if (!params.row.deleted) {
          return (
            <IconButton
              onClick={(e) => onButtonDeleteClick(e, params.row.storeId)}
            >
              <DeleteOutline />
            </IconButton>
          );
        }
      },
    },
  ];
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Lojas</div>

          <div className="cust-card">
            <div className="cust-section-header">Nova Loja</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Loja</label>
                <input
                  className="cust-input"
                  type="text"
                  name="store"
                  onChange={handleChange}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">CNPJ Integração (opcional)</label>
                <input
                  className="cust-input"
                  type="text"
                  name="integrationId"
                  placeholder="CNPJ da conta do ERP desta loja"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<SaveIcon />}
                onClick={addStore}
              >
                Adicionar Loja
              </Button>
            </div>
          </div>

          <div className="cust-card">
            <div className="cust-section-header">Lojas Cadastradas</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="storeList"
                rows={stores}
                columns={columns}
                pageSize={45}
                checkboxSelection={false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
